import { render, staticRenderFns } from "./ItemCardLongDescription.vue?vue&type=template&id=4cd1edf2&scoped=true"
import script from "./ItemCardLongDescription.vue?vue&type=script&lang=ts"
export * from "./ItemCardLongDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd1edf2",
  null
  
)

export default component.exports